import { render, staticRenderFns } from "./HomeAllRecordsComponent.vue?vue&type=template&id=74233032&scoped=true&"
import script from "./HomeAllRecordsComponent.vue?vue&type=script&lang=js&"
export * from "./HomeAllRecordsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74233032",
  null
  
)

export default component.exports